import {
  Box,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import NotificationSettingsTab from './settings/NotificationSettingsTab';
import ApiIntegrationTab from './settings/ApiIntegrationTab';
import ApiKeysTab from './settings/ApiKeysTab';
import PassageOutboundTab from './settings/PassageOutboundTab';
import PassageRetentionTab from './settings/PassageRetentionTab';
import BatchSettingsTab from './settings/BatchSettingsTab';

const Settings = () => {
  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.100">
      <Heading display="flex" alignItems="center" mb={6}>
        Configurações
      </Heading>

      <Tabs colorScheme="teal" variant="enclosed">
        <TabList>
          <Tab fontWeight="semibold">Notificações</Tab>
          <Tab fontWeight="semibold">Chaves de API</Tab>
          <Tab fontWeight="semibold">Integrações</Tab>
          <Tab fontWeight="semibold">Passagens</Tab>
          <Tab fontWeight="semibold">Lotes</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <NotificationSettingsTab />
          </TabPanel>
          <TabPanel>
            <ApiKeysTab />
          </TabPanel>
          <TabPanel>
            <Tabs colorScheme="teal" variant="soft-rounded" size="sm">
              <TabList>
                <Tab fontWeight="semibold">API de Infrações</Tab>
                <Tab fontWeight="semibold">Envio de passagens</Tab>
              </TabList>
              <TabPanels>
                <TabPanel px={0}>
                  <ApiIntegrationTab />
                </TabPanel>
                <TabPanel px={0}>
                  <PassageOutboundTab />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </TabPanel>
          <TabPanel>
            <PassageRetentionTab />
          </TabPanel>
          <TabPanel>
            <BatchSettingsTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Settings;
